// choices/vibeChoices.js
const vibeChoicesRo = [
  {
    label: "Liniște",
    value: "calm",
  },
  {
    label: "Activitate",
    value: "active",
  },

  {
    label: "Confort",
    value: "comfortable",
  },

  {
    label: "Eleganță",
    value: "elegant",
  },

  {
    label: "Creativitate",
    value: "creative",
  },
];

export default vibeChoicesRo;
